"use client";
import React from "react";
import Image from "next/image";
import SofiaBot from "@/components/SofiaBot";

export default function Home() {
  const sofiaBotRef = React.useRef(null);

  return (
    <>
      <main className="flex min-h-screen w-screen h-screen bg-white">
        <div
          className="relative w-full h-full cursor-pointer"
          onClick={() => sofiaBotRef.current?.newThread()}
        >
          <Image
            src="/img/Desktop-ARIA.png"
            fill
            style={{ objectFit: "cover" }}
            quality={100}
            alt="Hero image"
          />
        </div>
      </main>
      <SofiaBot ref={sofiaBotRef} />
    </>
  );
}
